import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import ReviewLineChart from './LineChart';
import AreaGraph from './AreaGraph';
import { format } from 'date-fns';
import TitleWithInfo from '../TitleWithInfo/TitleWithInfo';
import { filter_icon, filter_icon_vector } from '../SvgIcon/CommonSvgIcons';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  padding: 10px 25px;
  box-sizing: border-box;
`;
const DropdownContainer = styled.div`
  position: relative;
  display: inline-block;
`;
const DropdownMenu = styled.div`
  position: absolute;
  background: white;
  border: 1px solid #ccc;
  padding: 10px;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
  z-index: 10;
  width: 200px;
  right: 0px;
`;
const Title = styled.div`
  /* color: #636363; */
  font-family: Montserrat;
  font-size: 15px;
  font-weight: 500;
  color: #2a2929;

  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const ToggleButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;
  width: min-content;

  color: #fff;

  font-family: Montserrat;
  font-size: 14px;
  font-weight: 400;
  border-radius: 6px;
  border: 1px solid #d9d9d9;

  & :not(:first-child) {
    border-left: 1px solid #e4e4e4;
    border-radius: 0px;
  }
`;

const Option = styled.span`
  white-space: nowrap;
  cursor: pointer;
  color: #2a2929;
  border-radius: 0px;
  font-family: 'Inter';
  ${(props) =>
    props.selected &&
    `
      color: #fff;
      // background:#353CF7;
      background: linear-gradient(95.02deg, #A0D925 -65.35%, #006A68 100%);

      border-radius: 4px !important;
      font-weight: 500;
  `};
  padding: ${(props) => props.padding};
`;

const Span = styled.span`
  color: #2a2929;
  font-family: Inter;
  font-size: 11px;
  font-weight: 400;
  align-self: flex-end;
  margin-right: 10px;
  margin-bottom: -4px;
`;

const MainContainer = styled.div`
  flex: 1;
  /* display: flex; */
  width: ${(props) => props.graphWidth};
  margin: ${(props) => props.margin};
  align-items: center;
  margin-top: 10px;
  min-height: 300px;
`;

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding-right: 180px;
  padding-top: 50px;
  z-index: 9;
`;
const StyledButton = styled.button`
  cursor: pointer;
  font-size: 18px;
  font-weight: 600;
  border: 1px solid rgba(45, 137, 85, 1);
  color: rgba(45, 137, 85, 1);
  background: white;
  height: 35px;
  padding: 5px 20px;
  border-radius: 6px;

  // border: 0px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 5px;
`;
const MenuItem = styled.button`
  cursor: pointer;
  background: ${(props) => (props.active ? '#2d8955' : '#ffffff')};
  font-family: Montserrat;
  text-align: left;
  padding-left: 16px;
  font-weight: 400;
  font-size: 14px;
  color: ${(props) => (props.active ? '#FFFFFF' : '#2A2929')};
  border: none;
  height: 38px;
`;

const MenuItemWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;
const FilterOptions = ({
  filterChange,
  cancelFunction,
  selectedOptions,
  setSelectedOptions,
  channel,
  setChartType,
}) => {
  const [tempSelectedOptions, setTempSelectedOptions] =
    useState(selectedOptions);
  const [showFilterOptions, setShowFilterOptions] = useState(false);
  const [activeMenuItem, setActiveMenuItem] = useState('volume');
  const handleCheckboxChange = (event) => {
    const { id, checked } = event.target;
    setTempSelectedOptions((prev) =>
      checked ? [...prev, id] : prev.filter((item) => item !== id)
    );
  };

  const handleClearFunc = () => {
    setShowFilterOptions(false);
    setSelectedOptions(['likes_count', 'comments_count', 'reposts', 'views']);
    cancelFunction();
  };
  return (
    <DropdownContainer>
      <StyledButton onClick={() => setShowFilterOptions(!showFilterOptions)}>
        Filters {filter_icon_vector}
      </StyledButton>
      {showFilterOptions && (
        <DropdownMenu>
          <MenuItemWrapper>
            <MenuItem
              active={activeMenuItem === 'volume'}
              onClick={() => {
                setActiveMenuItem('volume');
              }}
            >
              Volume
            </MenuItem>
            <MenuItem
              active={activeMenuItem === 'engagements'}
              onClick={() => {
                setActiveMenuItem('engagements');
              }}
            >
              Engagements
            </MenuItem>
          </MenuItemWrapper>

          {activeMenuItem === 'engagements' && (
            <div style={{ marginTop: '10px' }}>
              <Options>
                <input
                  type='checkbox'
                  id='likes_count'
                  checked={tempSelectedOptions.includes('likes_count')}
                  onChange={handleCheckboxChange}
                  style={{ accentColor: '#2D8955' }}
                />
                <span className='checkbox-wrapper'></span>Likes
              </Options>
              <Options>
                <input
                  type='checkbox'
                  id='comments_count'
                  checked={tempSelectedOptions.includes('comments_count')}
                  onChange={handleCheckboxChange}
                  style={{ accentColor: '#2D8955' }}
                />
                <span className='checkbox-wrapper'></span> Comments
              </Options>
              {channel === 'youtube' && (
                <>
                 <Options>
                    <input
                      type='checkbox'
                      id='views'
                      checked={tempSelectedOptions.includes('views')}
                      onChange={handleCheckboxChange}
                      style={{ accentColor: '#2D8955' }}
                    />
                    <span className='checkbox-wrapper'></span> Views
                  </Options>
                </>
              )}
              {channel === 'facebook' && (
                <>
                  <Options>
                    <input
                      type='checkbox'
                      id='shares_count'
                      checked={tempSelectedOptions.includes('shares_count')}
                      onChange={handleCheckboxChange}
                      style={{ accentColor: '#2D8955' }}
                    />
                    <span className='checkbox-wrapper'></span> Shares
                  </Options>
                </>
              )}

              {channel === 'twitter' && (
                <>
                  <Options>
                    <input
                      type='checkbox'
                      id='reposts'
                      checked={tempSelectedOptions.includes('reposts')}
                      onChange={handleCheckboxChange}
                      style={{ accentColor: '#2D8955' }}
                    />
                    <span className='checkbox-wrapper'></span> Reposts
                  </Options>
                  <Options>
                    <input
                      type='checkbox'
                      id='views'
                      checked={tempSelectedOptions.includes('views')}
                      onChange={handleCheckboxChange}
                      style={{ accentColor: '#2D8955' }}
                    />
                    <span className='checkbox-wrapper'></span> Views
                  </Options>
                </>
              )}
            </div>
          )}
          <ButtonContainer>
            <div />
            <Button
              onClick={() => {
                setSelectedOptions(tempSelectedOptions);
                filterChange(tempSelectedOptions);
                setShowFilterOptions(false);
                setChartType(
                  activeMenuItem === 'engagements' ? 'Engagements' : 'Volume'
                );
                if (activeMenuItem === 'volume') {
                  handleClearFunc();
                }
              }}
              apply
            >
              Apply
            </Button>
          </ButtonContainer>
        </DropdownMenu>
      )}
    </DropdownContainer>
  );
};

const ToggleButton = ({
  options = [],
  onClick = () => {},
  padding = '5px 20px',
  option,
}) => {
  const [selectedOption, setSelectedOption] = useState(option || options[0]);
  const handleSelectOption = (option) => {
    setSelectedOption(option);
    onClick(option);
  };

  return (
    <ToggleButtonWrapper>
      {options.map((option) => (
        <Option
          selected={selectedOption === option}
          onClick={() => handleSelectOption(option)}
          padding={padding}
          key={option}
        >
          {option}
        </Option>
      ))}
    </ToggleButtonWrapper>
  );
};
const Container = styled.div`
  width: 200px;
  padding: 20px;
  background: #ffffff;
  border: 1px solid #a2a2a2;
  border-radius: 2px;
`;

const Options = styled.label`
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  font-size: 14px;
  cursor: pointer;

  /* Hide the default checkbox */
  input {
    display: none;
  }

  /* Custom checkbox style */
  .checkbox-wrapper {
    width: 13px;
    height: 13px;
    border: 2px solid #ccc;
    border-radius: 4px;
    display: inline-block;
    position: relative;
    margin-right: 10px;
    cursor: pointer;
    transition: border-color 0.2s ease;

    /* Style the checkmark when checked */
    &::before {
      content: '';
      position: absolute;
      top: 0px;
      left: 0px;
      width: 13px;
      height: 13px;
      background-color: transparent;
      border-radius: 2px;
      transition: background-color 0.2s ease;
    }
  }

  /* When the checkbox is checked, change the checkmark and border color */
  input:checked + .checkbox-wrapper::before {
    background-color: green; /* Green checkmark when checked */
  }

  input:checked + .checkbox-wrapper {
    border-color: green; /* Change border to green when checked */
  }
  input:checked + .checkbox-wrapper::before {
    background-color: green; /* Green background when checked */
    // background-image: url('data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 10 10"%3E%3Cpath fill="white" d="M3.293 5.293l1.414 1.414L7.707 3.707l-1.414-1.414L4 4.586 2.707 3.293z"%3E%3C/path%3E%3C/svg%3E'); /* White checkmark */
    background-repeat: no-repeat;
    background-position: center;

    content: '✔';
    position: absolute;
    color: white;
    font-size: 10px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
  border-top: 1px solid #a2a2a2;
  padding-top: 10px;
`;

const Button = styled.button`
  padding: 10px 20px;
  font-size: 16px;
  cursor: pointer;
  border: none;
  border-radius: 5px;

  ${({ apply }) =>
    apply
      ? `
     background: rgb(45, 137, 85);
    color: white;
  `
      : `
    background-color: #f5f5f5;
    color: #333;
  `}

  &:hover {
    opacity: 0.9;
  }
`;

const TrendsInUserActivity = ({
  data1,
  title,
  ylabel,
  option,
  hideDropdown,
  startDate,
  endDate,
  formatValue = 'dd-yyyy-MM',
  infoText = '',
  showFilters = false,
  channel,
  typeVal = '',
  handleDataPoint,
  onEmitTimeSpanClick,
  dataPointClickEnabled = false,
  setChartType,
}) => {
  const [timeSpan, setTimeSpan] = useState(option || 'Days');
  const [lineGraph, setLineGraph] = useState(true);
  const [showFilterOptions, setShowFilterOptions] = useState(false);
  const [showFiltereData, setShowFilteredData] = useState(false);
  const [filteredData, setFilteredData] = useState([]);
  const [selectedOptions, setSelectedOptions] = useState(
    channel == 'youtube'
      ? ['likes_count', 'comments_count', 'views'] :
    channel !== 'twitter'
      ? ['likes_count', 'comments_count', 'shares_count']
      : ['likes_count', 'comments_count', 'reposts', 'views']
  );

  let trendsInUserActivity;

  if (timeSpan === 'Days') {
    trendsInUserActivity = data1?.trends_in_user_activity?.days || {};
  } else if (timeSpan === 'Weeks') {
    trendsInUserActivity = data1?.trends_in_user_activity?.week || {};
  } else if (timeSpan === 'Months') {
    trendsInUserActivity = data1?.trends_in_user_activity?.month || {};
  } else if (timeSpan === 'Years') {
    trendsInUserActivity = data1?.trends_in_user_activity?.year || {}; //post API integration, update with year attribute
  }

  const timeline = trendsInUserActivity?.timeline || [];
  const reviewsCount =
    title === 'Impressions'
      ? trendsInUserActivity?.impression || []
      : trendsInUserActivity?.count || [];
  const engagementCount = trendsInUserActivity?.engagement_count || [];
  const likesCount = trendsInUserActivity?.likes_count || [];
  const commentsCount = trendsInUserActivity?.comments_count || [];
  const repostsCount = trendsInUserActivity?.reposts || [];
  const viewsCount = trendsInUserActivity?.views || [];
  const sharesCount = trendsInUserActivity?.shares_count || [];
  const userActivityData =
    timeline &&
    (likesCount || engagementCount || commentsCount || sharesCount) &&
    timeline.length > 0 &&
    (reviewsCount.length > 0 ||
      engagementCount.length > 0 ||
      likesCount.length > 0 ||
      sharesCount.length > 0 ||
      commentsCount.length > 0 || 
      viewsCount.length > 0
    )
      ? timeline
          .map((date, index) => {
            if (date) {
              if(typeVal == 'youtube' &&
                title == 'Trends in User Activity'){
                return {
                  date,
                  engagement_count: engagementCount[index] || 0,
                  likes_count: likesCount[index] || 0,
                  comments_count: commentsCount[index] || 0,
                  shares_count: sharesCount[index] || 0,
                  views : viewsCount[index] || 0
                  // [`${ylabel?.toLowerCase() || 'reviews'}`]: reviewsCount[index] || 0,
                };
              }else if (
                typeVal == 'instagram' &&
                title == 'Trends in User Activity'
              ) {
                return {
                  date,
                  engagement_count: engagementCount[index] || 0,
                  likes_count: likesCount[index] || 0,
                  comments_count: commentsCount[index] || 0,
                  shares_count: sharesCount[index] || 0
                  // [`${ylabel?.toLowerCase() || 'reviews'}`]: reviewsCount[index] || 0,
                };
              } else if (
                typeVal === 'twitter' &&
                title == 'Trends in User Activity'
              ) {
                {
                  return {
                    date,
                    engagement_count: engagementCount[index] || 0,
                    likes_count: likesCount[index] || 0,
                    comments_count: commentsCount[index] || 0,
                    reposts: repostsCount[index] || 0,
                    views: viewsCount[index] || 0,
                    // [`${ylabel?.toLowerCase() || 'reviews'}`]: reviewsCount[index] || 0,
                  };
                }
              } else {
                return {
                  date,
                  [`${ylabel?.toLowerCase() || 'reviews'}`]:
                    reviewsCount[index] || 0,
                };
              }
            }
            // Return null if the date is invalid, to be filtered later
            return null;
          })
          .filter((item) => item !== null) // Remove any null entries
      : [];

  function filterAndCleanData(data, filterKeys) {
    const keyMap = {
      likes_count: 'likes_count',
      comments_count: 'comments_count',
      reposts: 'reposts',
      views: 'views',
      shares_count: 'shares_count',
    };
    

    return data.map((entry) => {
      const newEngagementCount = filterKeys.reduce((sum, key) => {
        const field = keyMap[key];
        return sum + (entry[field] || 0);
      }, 0);

      const filteredEntry = {
        engagement_count: newEngagementCount,
        date: entry.date,
      };

      filterKeys.forEach((key) => {
        const field = keyMap[key];
        if (field && field in entry) {
          filteredEntry[key] = entry[field];
        }
      });

      return filteredEntry;
    });
  }
  
  const handleActiveFilter = (selectedFilter) => {
    setShowFilteredData(true);
    setSelectedOptions(selectedFilter);
    setFilteredData(filterAndCleanData(userActivityData, selectedFilter));
  };

  useEffect(() => {
    if (showFiltereData) {
      setFilteredData(filterAndCleanData(userActivityData, selectedOptions));
    }
  }, [timeSpan, userActivityData]);

  const handleTimeSpanClick = (option) => {
    if (onEmitTimeSpanClick !== undefined) {
      onEmitTimeSpanClick(option === 'Weeks' ? true : false);
    }
    setTimeSpan(option); // State updates, triggering useEffect
  };

  const handleGraphSelection = (option) => {
    setLineGraph((prev) => !prev);
  };

  return (
    <Wrapper>
      <Title>
        <p>
          <TitleWithInfo title={title} infoText={infoText} />
        </p>

        <div style={{ display: 'flex', gap: '10px' }}>
          {showFilters && (
            <FilterOptions
              selectedOptions={selectedOptions}
              channel={channel}
              setChartType={(data) => {
                setChartType(data);
              }}
              setSelectedOptions={(data) => {
                setSelectedOptions(data);
              }}
              cancelFunction={() => {
                setShowFilterOptions(false);
                setShowFilteredData(false);
              }}
              filterChange={(data) => {
                handleActiveFilter(data, userActivityData);
                setShowFilterOptions(false);
              }}
            />
          )}
          {hideDropdown !== true && (
            <ToggleButton
              options={['Line Graph', 'Area Graph']}
              onClick={handleGraphSelection}
              padding={'8px 20px'}
            />
          )}
        </div>
      </Title>
      {hideDropdown !== true && (
        <ToggleButton
          options={['Days', 'Weeks', 'Months', 'Years']} //add years once api is available
          onClick={handleTimeSpanClick}
          padding='3px 30px'
          option={option}
        />
      )}

      {userActivityData && (
        <MainContainer>
          {lineGraph ? (
            <ReviewLineChart
              height={370}
              data={showFiltereData ? filteredData : userActivityData}
              ylabel={ylabel}
              typeVal={typeVal}
              dataPointClickEnabled={dataPointClickEnabled}
              handleDataPoint={(data) => {
                if (selectedOptions?.length > 0) handleDataPoint(data);
              }}
              showTitle={title}
            />
          ) : (
            <AreaGraph
              height={370}
              data={showFiltereData ? filteredData : userActivityData}
              typeVal={typeVal}
              ylabel={ylabel}
              showTitle={title}
              dataPointClickEnabled={dataPointClickEnabled}
              handleDataPoint={(data) => {
                if (selectedOptions?.length > 0) handleDataPoint(data);
              }}
            />
          )}
        </MainContainer>
      )}
      {(startDate || endDate) && (
        <Span>
          This data is observed from {startDate} to {endDate}
        </Span>
      )}
    </Wrapper>
  );
};

export default TrendsInUserActivity;
